import styled from 'styled-components';

import { BUTTON_SIZES, GhostButton } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { ARROW_DIRECTION_DOWN, CollapsibleContentArrow } from 'ui/collapsibleContent';
import { colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { EventInfo, SystemEventName } from '../../../../domain';
import { EventIcon } from '../../../components/EventIcon';
import { isSystemEvent, getEventLabel } from '../../../utils';
import { TABLE_COLUMNS } from '../../constants';
import { Cell } from '../../../../components/table';

interface EventHistoryNameCellProps {
  userEvent: EventInfo;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

interface TooltipContentProps {
  eventName: SystemEventName | string;
}

const StyledCell = styled(Cell)`
  && {
    flex-direction: row;
    width: 100%;
    align-items: center;
  }
`;

const StyledTooltip = styled(Tooltip)`
  display: inline-flex;
`;

const EventLabel = styled.span`
  flex-grow: 1;
  margin: 0 ${pxToRem(10)};
`;

const displayContent = {
  iterable: 'Iterable event',
  custom: 'Custom event',
};

const TooltipContent = ({ eventName }: TooltipContentProps) =>
  isSystemEvent(eventName) ? <>{displayContent.iterable}</> : <>{displayContent.custom}</>;

export const EventHistoryNameCell = ({
  userEvent,
  isCollapsed,
  onToggleCollapse,
}: EventHistoryNameCellProps) => (
  <StyledCell data-test="event-history-name-cell" columnId={TABLE_COLUMNS.EVENT}>
    <StyledTooltip tooltipContent={<TooltipContent eventName={userEvent.eventType} />}>
      <EventIcon eventName={userEvent.eventType} color={colors.textSecondary} />
    </StyledTooltip>
    <EventLabel data-test="name-cell-label">{getEventLabel(userEvent)}</EventLabel>
    <GhostButton onClick={onToggleCollapse} size={BUTTON_SIZES.SMALL}>
      <CollapsibleContentArrow
        isCollapsed={isCollapsed}
        arrowStart={ARROW_DIRECTION_DOWN}
        arrowEnd={180}
        width={16}
        height={16}
      />
    </GhostButton>
  </StyledCell>
);
